import { Component, OnInit } from '@angular/core';
import * as Cookies from 'js-cookie';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PlanService } from 'src/app/services/plan-status/plan-status.service';
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-select-request-modal',
  templateUrl: './select-request-modal.component.pug',
  styleUrls: ['./select-request-modal.component.scss'],
  standalone: false
})
export class SelectRequestModalComponent implements OnInit {

  selectedOrgUid = Cookies.get(ConstantsService.ORG_COOKIE);
  message:any;
  showLink:any;
  contactLink = ConstantsService.ACCOUNT_MANAGER_CONTACT
  mergedContactLink = ''

  constructor(
    public _bsModalRef:BsModalRef,
    private permissions: PermissionsService,
    public planservice: PlanService
  ) { }

  ngOnInit(): void {
    this.contactLink = ConstantsService.ACCOUNT_MANAGER_CONTACT;
  }

  select(surveyType): void {

  }

  contactAccount(){
    this.planservice.getSFDCid().subscribe(
      res => {
        this.mergedContactLink = this.contactLink + res.data.sf_account
        window.open(this.mergedContactLink)
      },
      err => {
        window.open(this.mergedContactLink)
      }
    )
  }

  cancel(): void {
    this._bsModalRef.hide()
  }

    protected readonly ConstantsService = ConstantsService;
}
